/**
 * wrapper around native location.assign to make it easier to mock in e2e tests
 * reference: https://glebbahmutov.com/blog/stub-location/
 **/
export const LocationHelper = {
  assign: (url: string) => {
    location.assign(url);
  },
};
